module.exports = __webpack_public_path__ + "static/media/owner.965e749a.jpeg";